<template>
<div>
	<div v-if="basicData" class="view-details-header bg-primary position-relative course-detail-header">
		<div v-if="basicData.thumbnail" class="header-image">
      <img :alt="basicData.name" :src="basicData.thumbnail"></div>
		<div class="header-overlay"></div>
		<div class="container container--narrow position-relative pdt-30 pdb-30 pdl-16 pdr-16">
			<div class="d-flex justify-content-between align-items-center">
				<div class="t-headline11 t-color-whiteHigh font-m flex-grow-1 pdr-24">
					{{basicData.name}}
				</div>
						<div
							class="pdl-16 position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle">
							<i class="material-icons mdc-icon-button t-color-whiteHigh t-headline6 js--dropdown-toggle" tabindex="0" @click.prevent="toggleAddedMenu" @keypress.prevent="toggleAddedMenu">more_vert</i>
							<div id="addedMenu" class="mdc-menu mdc-menu-surface toggle-menu">
								<ul aria-hidden="true" aria-orientation="vertical" class="mdc-list" role="menu"
									tabindex="-1">
									<li class="mdc-list-item" role="menuitem"  tabindex="0" @click.prevent="moveToCourse()" @keypress.prevent="moveToCourse()">
										<span class="mdc-list-item__ripple"></span>
										<span class="mdc-list-item__text t-body6 font-r">{{$t('210')}}</span>
									</li>
<!--									<li class="mdc-list-item" role="menuitem" tabindex="0" @click="moveToReward(basicData.degreeId)" @keypress="moveToReward(basicData.degreeId)">-->
<!--										<span class="mdc-list-item__ripple"></span>-->
<!--										<span class="mdc-list-item__text t-body6 font-r">{{$t('211')}}</span>-->
<!--									</li>-->
								</ul>
							</div>
						</div>
			</div>
			<div class="t-body6 t-color-whiteHigh font-r pdt-16 pdb-8">
				{{basicData.category.text}}{{basicData.category.child ? ' > ' + basicData.category.child.text : ''}}
			</div>
			<div v-if="basicData.levels.length" class="t-body6 t-color-whiteHigh font-r pdb-12">
				<span v-for="(level, index) in basicData.levels" :key="index">
					{{level.text}} {{basicData.levels.length === index+1 ? '' : '/' }}
				</span>
			</div>
			<div v-if="basicData.tags.length" class="mdc-chip-set banner--chip chip--outlined" role="grid">
				<div v-for="(tag, index) in basicData.tags" :key="index" class="mdc-chip " role="row">
					<!-- <div class="mdc-chip__ripple"></div> -->
					<span role="gridcell">
						<span class="mdc-chip__text t-body4 font-r">#{{tag.name}}</span>
					</span>
				</div>
			</div>
			<div v-if="statusTab=='LEARNING'" class="d-flex align-items-baseline justify-content-between mgt-29">
				<div class="d-flex align-items-baseline">
					<div class="t-headline5 pdr-8  t-color-whiteHigh font-b font-rb">
            {{$t('138', {str: parseInt(basicData.progression)})}}
					</div>
				</div>
				<div v-if="basicData.learnRemainDays <= 30" class="t-headline5 pdr-8  t-color-whiteHigh font-b font-rb">	{{$t('156', {str: basicData.learnRemainDays})}}</div>
			</div>
			<div v-if="statusTab=='COMPLETION'" class="d-flex align-items-baseline justify-content-between mgt-29">
				<div class="d-flex align-items-baseline">
				<div v-if="basicData.learningStatus.value=='COMPLETION'" class="t-headline5 pdr-8  t-color-whiteHigh font-b font-rb">
					{{ $t('1307') }}
				</div>
					<div v-else class="t-headline5 pdr-8  t-color-whiteHigh font-b font-rb">
							{{ $t('1310') }}
					</div>
				</div>
			</div>
			<div v-if="statusTab=='WAITING'" class="mgt-14">
				<button class="mdc-button mdc-button--raised w-full bg-disableBtn t-color-disableBtnText mdc-ripple-upgraded" >
					{{basicData.periodLearning.start ? $t('1306', {str: $moment(basicData.periodLearning.start).format('L')}) : ''}}
				</button>
			</div>
		</div>
	</div>
	<div class="divider"></div>
</div>
</template>

<script>
/**
 * 나의 학습 상세 - header 컴포넌트(my learning view - header component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCMenuSurface} from '@material/menu-surface'

export default {
	props: ['basicData'],
	data() {
		return {
			addedMenu: null,
			statusTab: null,
		}
	},
	watch:{
	  '$route' (to, from){
		  this.statusTab = this.$route.query.status;
	  },
	},
	updated() {
		// 네비게이션 메뉴 설정(set navigation menu)
		this.addedMenu = MDCMenuSurface.attachTo(document.getElementById('addedMenu'))
		this.addedMenu.setAnchorMargin({
			bottom: 10,
			left: 10,
			right: 16,
			top: 40,
		})

	},
	  mounted() {
		window.mdc.autoInit();
		const selector = '.mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set';
		this.statusTab = this.$route.query.status;
		if(document.querySelectorAll('.toggle-menu')){
		const menuEls = Array.from(document.querySelectorAll('.toggle-menu'));
		menuEls.forEach((menuEl) => {
			// Initialize MDCSimpleMenu on each ".mdc-simple-menu"
			const menu = new mdc.menu.MDCMenu(menuEl);
			// We wrapped menu and toggle into containers for easier selecting the toggles
			const dropdownToggle = menuEl.parentElement.querySelector('.js--dropdown-toggle');
			dropdownToggle.addEventListener('click', () => {
				menu.open = !menu.open;
			});
		});
}
	   // console.log("basicDatabasicData",this.basicData);

	},
	methods: {
		// 네비게이션 메뉴 토글(toggle navigation menu)
		toggleAddedMenu() {
			this.addedMenu.open = !this.addedMenu.open
		},

    moveToCourse() {
      this.$router.push({
        name: 'MicroCourseView',
        params: {
          degreeId: this.basicData.degreeId
        }
      })
    },

    moveToReward() {
      this.$router.push({
        name: 'MicroCourseView',
        params: {
          degreeId: this.basicData.degreeId
        }
      });
    },

		 moveLearnList() {
			 let learnBack = localStorage.getItem("learnDetails")
			 if (learnBack === 'backtoList') {
				 this.$router.push({
					 name: 'MicroDegree',
					 query: this.$route.query
				 })
			 }
			 if (learnBack === 'backtoMain') {
				 this.$router.push('/home')
			 }
		}
	}
}
</script>
